import type { PlatformSaleItemEntity, PlatformSaleListingItemEntity } from '~/types/sale.type';

export const useTrackingGlobalSale = (): Ref<PlatformSaleItemEntity | undefined> =>
    useState<PlatformSaleItemEntity | undefined>('trackingGlobalSale', () => undefined);

export const useTrackingGlobalSales = (): Ref<PlatformSaleListingItemEntity[] | undefined> =>
    useState<PlatformSaleListingItemEntity[] | undefined>('trackingGlobalSales', () => undefined);

export const useTrackingReferralListName = (): Ref<string | null> => useState<string | null>('trackingReferralListName', () => null);
